import {ColumnPropertyLazySelect, GetSelectDataParams} from "../../../../core/types/records-table.types";
import {BaseFormField} from "../../../../core/types/form-field.types";

export const productCardParameterFields: Array<BaseFormField> = [
  {
    label: 'Вес',
    fieldName: 'productWeight'
  },
  {
    label: 'Цвет',
    fieldName: 'productColor'
  },
  {
    label: 'Запах',
    fieldName: 'productScent'
  },
  {
    label: 'Литраж/объём',
    fieldName: 'productVolume'
  }
]

export const fieldToIdKey = {
  productWeight: 'productWeightId' as const,
  productColor: 'productColorId' as const,
  productScent: 'productScentId' as const,
  productVolume: 'productVolumeId' as const
};

export const productWeightsPropertyLazy: ColumnPropertyLazySelect = {
  recourseName: 'ProductWeight',
  providerType: 'DEFAULT'
}

export const productColorsPropertyLazy: ColumnPropertyLazySelect = {
  recourseName: 'ProductColor',
  providerType: 'DEFAULT'
}

export const productScentsPropertyLazy: ColumnPropertyLazySelect = {
  recourseName: 'ProductScent',
  providerType: 'DEFAULT'
}

export const productVolumesPropertyLazy: ColumnPropertyLazySelect = {
  recourseName: 'ProductVolume',
  providerType: 'DEFAULT'
}

export const propertyLazyProductParameters: Array<GetSelectDataParams> = [
  {
    propertyLazySelect: productWeightsPropertyLazy
  },
  {
    propertyLazySelect: productColorsPropertyLazy
  },
  {
    propertyLazySelect: productScentsPropertyLazy
  },
  {
    propertyLazySelect: productVolumesPropertyLazy
  }
]
